import React from 'react';

import Image from '~/src/components/image/Image';
import Caption from '~/src/components/caption/Caption';

const ImageWrapper = (props) => {
    const {caption, credit, showCaption = true} = props;
    if (showCaption && (caption || credit)) {
        return (
            <Caption {...props}>
                <Image hasBackgroundImage={props.isTitleElement} {...props} />
            </Caption>
        );
    }
    return <Image hasBackgroundImage={props.isTitleElement} {...props} />;
};

export default ImageWrapper;
